(function ($) {
    //--------------------------------------------------
    // jQuery Helper Methods
    //--------------------------------------------------

    $.fn.wait = function (time, type) {
        time = time || 1000;
        type = type || 'fx';

        return this.queue(type, function () {
            var $self = $(this);
            setTimeout(function () {
                $self.dequeue();
            }, time);
        });
    };

    $.fn.msg = function (time, fade) {
        time = time || 4500;
        fade = fade || 500;

        $(this).wait(time).fadeOut(fade, function () {
            $(this).remove();
        });
    };

    //--------------------------------------------------
    // Variables
    //--------------------------------------------------

    var $body = $('body');
    var surveyFormSelector = '#fragebogen_form';
    var $surveyForm = $(surveyFormSelector);
    var $descriptionAccordions = $('.question-form__content');

    //--------------------------------------------------
    // Methods
    //--------------------------------------------------

    function validateSurveyPage() {
        var data = $surveyForm.serialize();
        var $button = $surveyForm.find('.button--forward');
        var valid = false;
        var request;

        $button.addClass('is--loading');

        request = $.ajax('fragebogen/ajaxsave', {
            cache: false,
            context: $surveyForm,
            data: data,
            async: false,
            dataType: 'json',
            type: 'GET'
        });

        request.done(function (data) {
            if (data.success === true) {
                valid = true;
            } else {
                if (data.validation && $.isArray(data.validation)) {
                    $.each(data.validation, function () {
                        $('#frage-' + this).addClass('has--error');
                    });
                } else {
                    alert(data.msg);
                }
            }
        });

        if (!valid) {
            $button.removeClass('is--loading');
            $('#invalid-survey-form').modal();
        }

        return valid;
    }

    //--------------------------------------------------
    // Function Calls
    //--------------------------------------------------

    // Hide and remove initial messages after time
    $('#messages').find('.messages__message').msg();

    // Navigation Overlays
    $body.on('click', '.navigation__button', function (e) {
        e.preventDefault();
        var $navigation = $('.navigation');
        var type = $(this).data('type');
        var isVisible = $navigation.hasClass('navigation--show-' + type);

        $navigation.removeClass(function (index, className) {
            return (className.match(/(^|\s)navigation--show-\S+/g) || []).join(' ');
        });

        if (!isVisible) {
            $navigation.addClass('navigation--show-' + type);
        }

        return false;
    });

    $body.on('click', function (e) {
        var self = $(e.target);
        var $navigation = $('.navigation');
        if (self.is('a') || (!self.hasClass('navigation__button') && !self.hasClass('navigation__overlay') && !self.parents('.navigation__overlay').length)) {
            $navigation.removeClass(function (index, className) {
                return (className.match(/(^|\s)navigation--show-\S+/g) || []).join(' ');
            });
        }
    });

    // Passwort set form
    $body.on('submit', '#fragebogen-passwort', function (e) {
        e.preventDefault();
        var $self = $(this);
        var data = $self.serialize();
        var url = $self.attr('action');
        var type = $self.attr('method').toUpperCase();

        var request = $.ajax(url, {
            cache: false,
            context: this,
            data: data,
            async: false,
            dataType: 'json',
            type: type
        });

        request.done(function (data) {
            if (data.success) {
                $.modal.close();
                window.location.reload();
            } else {
                $(this).replaceWith(data.html);
            }
        });
    });

    // Form Actions
    if ($surveyForm.length) {
        $body.on('change', surveyFormSelector + ' .question-row__group-answer input', function () {
            $(this).parents('.question-block__question').removeClass('has--error');
        });

        $body.on('click', surveyFormSelector + ' :submit', function () {
            $(this).parents('form').data('submit_button', $(this));
        });

        $body.on('submit', surveyFormSelector, function (e) {
            var $self = $(this);
            var submitButton = $self.data('submit_button');
            $self.removeData('submit_button');

            if (submitButton && $(submitButton).val() === 'back') {
                return true;
            }

            if (!validateSurveyPage()) {
                e.preventDefault();
            }
        });
    }

    if ($descriptionAccordions.length) {
        $descriptionAccordions.find('.question-form__handle').on('click', function (e) {
            e.preventDefault();
            $(this).parents($descriptionAccordions).toggleClass('is--open');
            return false;
        });
    }

})(jQuery);
